import {
    ValidationResult,
    ValidationFailure,
    ensure,
    getFileInfo,
    createFailure,
    createValidationResult
} from "sprint-common-web";

const availablePresetExtensions = ["mps"];

export const validatePresetFile = (path: string | undefined, size: number | undefined): ValidationResult => {
    const failures: ValidationFailure[] = [];
    ensure(path);

    const { extension } = getFileInfo(path);

    if (!isFileExtensionValid(extension)) {
        const failure = createFailure(
            `Availabe file extensions: '${availablePresetExtensions.join("', '")}'`,
            "fileExtension"
        );

        failures.push(failure);
    }

    if (size === 0) {
        const failure = createFailure("File cannot be empty", "fileSize");

        failures.push(failure);
    }

    return createValidationResult(failures);
};

const isFileExtensionValid = (extension: string): boolean => {
    return availablePresetExtensions.includes(extension);
};
